import {Component, Input} from '@angular/core';
import {Step} from '@shared/models/step.model';

@Component({
  selector: 'hmt-progress-tab-line',
  templateUrl: './progress-tab-line.component.html',
  styleUrls: ['./progress-tab-line.component.scss'],
  standalone: false
})
export class ProgressTabLineComponent {
  @Input() steps: Step[] = [];
  @Input() currentStep: string;

  isActive(step: Step): boolean {
    return step?.step === this.currentStep;
  }
}
